import { render, staticRenderFns } from "./private-policy.vue?vue&type=template&id=50596efc&"
import script from "./private-policy.vue?vue&type=script&lang=js&"
export * from "./private-policy.vue?vue&type=script&lang=js&"
import style0 from "./private-policy.vue?vue&type=style&index=0&id=50596efc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports